<template>
  <v-app-bar app :clipped-left="$vuetify.breakpoint.mdAndUp" fixed>

    <v-app-bar-nav-icon @click.stop="leftBar()" color="black"></v-app-bar-nav-icon>

    <v-spacer></v-spacer>

    <span class="ma-0" v-if="nomeCliente && nomeCliente != utente" id="mobile-nav" style="cursor: pointer">
      {{ nomeCliente }}
    </span>

    <v-spacer></v-spacer>

    <!-- Cliente selezionato -->
    <span style="padding-right: 10px" v-if="getRole != 'utente' && nomeCliente != utente">
      {{ nomeCliente }}

      <v-btn v-if="getRole != 'utente' &&
        nomeCliente != '' &&
        nomeCliente != null &&
        nomeCliente != undefined &&
        nomeCliente != utente
      " style="margin-top: -0.5em" icon small v-on:click="rimuoviCliente">
        <v-icon>close</v-icon>
      </v-btn>
    </span>

    <!-- Utente -->
    <v-toolbar-title style="font-size:16px; font-weight: normal;  ">{{ utente }}</v-toolbar-title>

    <!-- Menu utente -->
    <v-menu offset-y :close-on-click="true" :close-on-content-click="true" :nudge-width="200">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon large>
            account_circle
          </v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-list>
          <v-list-item style="cursor: pointer" v-on:click="account">
            <v-list-item-avatar>
              <v-icon :x-large="true">account_circle
              </v-icon>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>Utente :</v-list-item-title>
              <v-list-item-subtitle>{{ utente }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-card-actions>
          <!-- <v-btn
            :disabled="disabilitaBtn"
            flat
            v-on:click="account"
          ><v-icon center dark>person</v-icon>Account</v-btn> -->
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="disabilitaBtn" text v-on:click="esci">
            <v-icon center dark>exit_to_app</v-icon>Esci
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </v-app-bar>
</template>


<script>
export default {
  props: {
    utente: { type: String, default: "" },
    compCode: { type: String, default: "" },
    nomeCliente: { type: String, default: "" },
  },

  data: () => ({
    disabilitaBtn: false,
  }),

  methods: {
    esci() {
      this.disabilitaBtn = true;

      this.$emit("esci");
    },

    leftBar() {
      this.$emit("showLeftBar");
    },

    account() {
      this.$router.push({ path: "/account" });
    },

    rimuoviCliente() {
      this.$store.commit("user/CLEAR_COMPANYDATA");
    },
  },

  computed: {
    getRole() {
      return this.$store.getters["user/getRole"];
    },
  },
};
</script>
